/* eslint-disable array-callback-return */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect } from "react";
import {
  IRoleMenu,
  useAddRoleMenu,
  useGetAllMenuList,
  useGetAllRoleList,
  useUpdateRoleMenu,
} from "../../../hooks";
import {
  Autocomplete,
  Box,
  Checkbox,
  FormControl,
  Stack,
  Typography,
  TextField,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  BaseModal,
  BaseModalProps,
  SelectControl,
  SwitchControl,
} from "../../molecules";
import { Button } from "../../atoms";
import { useForm, Controller } from "react-hook-form";
import { useMemo, useState } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { useSetSnackBar } from "../../../store/Snackbar.state";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  roleMenuAddFormSchema,
  RoleMenuAddFormSchemaFormValuesType,
  roleMenuAddInitialValues,
} from "./_formTypes";

export type RoleMenuAddModalProps = BaseModalProps & {
  title?: string;
  roleMenu?: any;
};

export const RoleMenuAddModal = ({
  onClose,
  isOpen,
  roleMenu,
  title = "Role Menü Ekle",
}: RoleMenuAddModalProps) => {
  const { control, reset, handleSubmit } =
    useForm<RoleMenuAddFormSchemaFormValuesType>({
      resolver: zodResolver(roleMenuAddFormSchema),
      defaultValues: roleMenuAddInitialValues,
    });
  const [selectedMenuIds, setSelectedMenuIds] = useState([] as any);
  const [selectedMenuIdsObject, setSelectedMenuIdsObject] = useState([] as any);

  const [selectedRoleIds, setSelectedRoleIds] = useState([] as any);
  const [selectedRoleIdsObject, setSelectedRoleIdsObject] = useState([] as any);

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [selectAll, setSelectAll] = useState(false);
  const [roleIdSelectAll, setRoleIdSelectAll] = useState(false);
  const { data: rawMenuList } = useGetAllMenuList("ACTIVE")
  const { data: rawRoleList } = useGetAllRoleList("ACTIVE")
  const { mutate: addRoleMenu } = useAddRoleMenu();
  const { mutate: updateRoleMenu } = useUpdateRoleMenu();
  const setSnackbar = useSetSnackBar();
  const [tableData, setTableData] = useState();

  useEffect(() => {
    if (!!roleMenu && JSON.stringify(roleMenu) !== "{}") {
      reset({
        roleId: roleMenu.roleId,
        //menuIds: roleMenu.menuIds,
        read: roleMenu?.read,
        update: roleMenu?.update,
        create: roleMenu?.create,
        delete: roleMenu?.delete,
      });
      setSelectedMenuIds([
        { label: roleMenu?.menuName, value: roleMenu?.menuId },
      ]);
      setSelectedMenuIdsObject([
        { label: roleMenu?.menuName, value: `${roleMenu?.menuId}` },
      ]);
    }
  }, [reset, roleMenu]);

  const roleList = useMemo(() => {
    return rawRoleList?.data?.map((menu: { name: string; id: number }) => {
      return {
        label: menu.name,
        value: `${menu.id}`,
      };
    });
  }, [rawRoleList?.data]);



  const menuList = useMemo(() => {
    const list = Array.isArray(rawMenuList?.data)
      ? rawMenuList.data.map((menu: { name: string; id: number }) => {
        return {
          label: menu.name,
          value: `${menu.id}`,
        };
      })
      : [];  // Eğer dizi değilse, boş bir dizi döndürüyoruz

    return [{ label: "Hepsini Seç", value: "all" }, ...list];
  }, [rawMenuList?.data]);



  const onSubmit = (data: RoleMenuAddFormSchemaFormValuesType) => {
    const request = {
      ...data,
      roleId: selectedRoleIds,
      menuIds: selectedMenuIds,
    };

    if (roleMenu && roleMenu?.id > 0) {
      updateRoleMenu(
        { ...data, id: roleMenu.id, menuId: selectedMenuIds[0]?.value || 0 },
        {
          onSuccess(data) {
            if (data.isSuccess) {
              setTableData(data.data)
              onClose();
              setSnackbar({
                severity: "success",
                isOpen: true,
                description: data.message,
              });
            } else {
              setSnackbar({
                severity: "error",
                isOpen: true,
                description: data.message,
              });
            }
          },
          onError: () => {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: "İşlem sırasında bir hata oluştu",
            });
          },
        }
      );
    } else {
      addRoleMenu(request, {
        onSuccess(data) {
          if (data.isSuccess) {
            setTableData(data.data)
            onClose();
            setSnackbar({
              severity: "success",
              isOpen: true,
              description: data.message,
            });
          } else {
            setSnackbar({
              severity: "error",
              isOpen: true,
              description: data.message,
            });
          }
        },
        onError: () => {
          setSnackbar({
            severity: "error",
            isOpen: true,
            description: "İşlem sırasında bir hata oluştu",
          });
        },
      });
    }
  };

  const handleMenuListChange = (event: any, selectedValues: any) => {

    const isSelectAllOptionSelected = selectedValues?.some((e: { label: string; value: any }) => e.value === "all");

    let list: Array<number | string> = [];

    if (isSelectAllOptionSelected) {
      if (selectAll) {
        setSelectAll(false);    // Hepsini Seç durumunu güncelliyoruz
      } else {
        const allMenuValues = menuList?.filter(e => e.value !== "all");
        list = allMenuValues?.map(e => e.value);
        setSelectAll(true);  // Hepsini Seç durumunu güncelliyoruz
      }
    } else {
      selectedValues?.map((e: { label: string; value: number | string }) => {
        list?.push(e.value);
      });
      setSelectAll(false);  // Hepsini Seç durumunu güncelliyoruz
    }

    setSelectedMenuIds(list);
    setSelectedMenuIdsObject(list?.map(val => menuList?.find(item => item?.value === val)));
  };

  const handleRoleListChange = (event: any, selectedValues: any) => {

    const isSelectAllOptionSelected = selectedValues?.some((e: { label: string; value: any }) => e.value === "all");

    let list: Array<number | string> = [];

    if (isSelectAllOptionSelected) {
      if (roleIdSelectAll) {
        setRoleIdSelectAll(false);    // Hepsini Seç durumunu güncelliyoruz
      } else {
        const allMenuValues = roleList?.filter(e => e.value !== "all");
        list = allMenuValues?.map(e => e.value);
        setRoleIdSelectAll(true);  // Hepsini Seç durumunu güncelliyoruz
      }
    } else {
      selectedValues?.map((e: { label: string; value: number | string }) => {
        list?.push(e.value);
      });
      setRoleIdSelectAll(false);  // Hepsini Seç durumunu güncelliyoruz
    }

    setSelectedRoleIds(list);
    setSelectedRoleIdsObject(list?.map(val => roleList?.find(item => item?.value === val)));
  };

  useEffect(() => {
    if (isOpen === false) {
      reset({});
    }
  }, [isOpen]);

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  return (
    <BaseModal onClose={onClose} title={title} isOpen={isOpen}>
      <Stack flex={1} p={4}>
        {/* !!! --- FORM --- !!! */}
        <Stack spacing={2} flex={1}>
          <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>
            {/* <FormControl sx={{ flex: 1, width: isDesktop ? "auto" : "100%" }}>
              {roleList && (
                <SelectControl
                  items={roleList}
                  size="medium"
                  sx={{ width: "100%" }}
                  id="roleId"
                  label="Rol"
                  control={control}
                />
              )}
            </FormControl> */}
            <FormControl sx={{ flex: 1, width: isDesktop ? "auto" : "100%", }}>
              {roleList && (
                <Controller

                  control={control}
                  name="roleId"
                  render={({
                    field: { onChange, value },
                    fieldState: { error, invalid },
                  }) => {
                    return (
                      <Autocomplete
                        multiple
                        id="roleId"
                        disabled={roleMenu && roleMenu?.id > 0}
                        onChange={(event, selectedValue) => {
                          setSelectedRoleIdsObject(selectedValue);
                          handleRoleListChange(event, selectedValue);
                          onChange(selectedValue)
                        }}
                        ListboxProps={{
                          style: { maxHeight: '400px', overflow: 'auto' }
                        }}
                        value={selectedRoleIdsObject}
                        options={roleList}
                        disableCloseOnSelect
                        getOptionLabel={(option: {
                          label: string;
                          value: string;
                        }) => option.label}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={option.value === "all" ? selectAll : selected}
                              value={option.value}
                            />
                            {option.label}
                          </li>
                        )}

                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Rol"
                            placeholder=""
                            error={invalid}
                            sx={{
                              '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
                                maxHeight: '200px',
                                overflowY: 'auto',
                              },
                              '& .MuiOutlinedInput-input': {
                                maxHeight: '200px',
                                overflowY: 'auto'
                              },

                            }}
                          />
                        )}
                      />
                    );
                  }}
                />
              )}
            </FormControl>
            <Box flex={1} sx={{ width: isDesktop ? "auto" : "100%" }}>
              <SwitchControl
                defaultValue={false}
                label="Okuma Yetkisi"
                control={control}
                id="read"
              />
            </Box>
          </Stack>
          <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>
            <Box flex={1} sx={{ width: isDesktop ? "auto" : "100%" }}>
              <SwitchControl
                defaultValue={false}
                label="Güncelleme Yetkisi"
                control={control}
                id="update"
              />
            </Box>
            <Box flex={1} sx={{ width: isDesktop ? "auto" : "100%" }}>
              <SwitchControl
                defaultValue={false}
                label="Yazma Yetkisi"
                control={control}
                id="create"
              />
            </Box>
          </Stack>
          <Stack alignItems="center" direction={isDesktop ? "row" : "column"} spacing={2}>
            <Box flex={1} sx={{ width: isDesktop ? "auto" : "100%" }}>
              <SwitchControl
                defaultValue={false}
                label="Silme Yetkisi"
                control={control}
                id="delete"
              />
            </Box>
            <Box flex={1}></Box>
          </Stack>
          <Stack direction="row" alignItems="center" spacing={2}>
            <Typography>Menü Seçimi</Typography>
          </Stack>
          <Stack alignItems="center" direction={isDesktop ? "row" : "column"} >
            <FormControl sx={{ flex: 1, width: isDesktop ? "auto" : "100%", }}>
              {menuList && (
                <Controller

                  control={control}
                  name="menuIds"
                  render={({
                    field: { onChange, value },
                    fieldState: { error, invalid },
                  }) => {
                    return (
                      <Autocomplete
                        multiple
                        id="menuIds"
                        disabled={roleMenu && roleMenu?.id > 0}
                        onChange={(event, selectedValue) => {


                          setSelectedMenuIdsObject(selectedValue);
                          handleMenuListChange(event, selectedValue);
                          onChange(selectedValue)
                        }}
                        ListboxProps={{
                          style: { maxHeight: '400px', overflow: 'auto' }
                        }}
                        value={selectedMenuIdsObject}
                        options={menuList}
                        disableCloseOnSelect
                        getOptionLabel={(option: {
                          label: string;
                          value: string;
                        }) => option.label}
                        renderOption={(props, option, { selected }) => (
                          <li {...props}>
                            <Checkbox
                              icon={icon}
                              checkedIcon={checkedIcon}
                              style={{ marginRight: 8 }}
                              checked={option.value === "all" ? selectAll : selected}
                              value={option.value}
                            />
                            {option.label}
                          </li>
                        )}

                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Menü Listesi"
                            placeholder=""
                            error={invalid}
                            sx={{
                              '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
                                maxHeight: '200px',
                                overflowY: 'auto',
                              },
                              '& .MuiOutlinedInput-input': {
                                maxHeight: '200px',
                                overflowY: 'auto'
                              },

                            }}
                          />
                        )}
                      />
                    );
                  }}
                />
              )}
            </FormControl>
          </Stack>
        </Stack>
        {/* !!! --- Button --- !!! */}
        <Stack justifyContent="flex-end" alignItems="center" direction="row">
          <Button
            variant="contained"
            text={roleMenu ? "Güncelle" : "Ekle"}
            onClick={handleSubmit(onSubmit)}
          />
        </Stack>
      </Stack>
    </BaseModal>
  );
};
